import type { UploadFacebookTemplateJobReport } from '@adflow/shared/data-facebook-ads';
import type { UploadGoogleAdsTemplateJobReport } from '@adflow/shared/data-google-ads';
import type { UploadGMBTemplateJobReport } from '@adflow/shared/data-google-my-business';

export const ServerToClientEvents = {
	CONNECTION: 'connect',
	SessionMutated: 'session mutated',
	JobUpdated: 'job updated',
	FacebookAdsUploadProgress: 'facebook ads upload progress',
	GoogleAdsUploadProgress: 'google ads upload progress',
	FacebookAdsTemplateUploaded: 'facebook ads template uploaded',
	GoogleAdsTemplateUploaded: 'google ads template uploaded',
	GoogleMyBusinessTemplateUploaded: 'google my business template uploaded',
	FacebookPagesExportCompleted: 'facebook pages export completed',
} as const;

/** This rename is just to reduce repeated text in the interface below. */
const e = ServerToClientEvents;

/**
 * Map of event names to the typeof the event listeners.
 */
export interface ServerToClientEvents {
	[e.CONNECTION]: () => void;
	[e.SessionMutated]: () => void;
	[e.FacebookAdsUploadProgress]: (data: {
		templateId: number;
		complete: number;
		total: number;
	}) => void;
	[e.GoogleAdsUploadProgress]: (data: {
		templateId: number;
		complete: number;
		total: number;
	}) => void;
	[e.FacebookAdsTemplateUploaded]: (
		data: UploadFacebookTemplateJobReport
	) => void;
	[e.GoogleAdsTemplateUploaded]: (
		data: UploadGoogleAdsTemplateJobReport
	) => void;
	[e.GoogleMyBusinessTemplateUploaded]: (
		data: UploadGMBTemplateJobReport
	) => void;
	[e.FacebookPagesExportCompleted]: (data: { fileName: string }) => void;
}
